module.exports = __webpack_public_path__ + "media/images/referrals/gift-72ea7a85fe045fc4dcd7cf095623948b.svg";